import { defineNuxtPlugin, useRuntimeConfig } from "nuxt/app";
import Logger from "./logger";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  const logInstance: Logger = Logger.getInstance({
    enabled: config.public.logger.enabled,
    singleLine: config.public.logger.singleLine,
    output: config.public.logger.output === "file" ? "file" : "pretty",
  });

  return {
    provide: {
      logger: logInstance,
    },
  };
});
